<template>
    <v-container fluid>
      <v-row>
        <v-col cols="6">
          <v-text-field
            :label="$t('name')"
            type="text"
            v-model="item.name"
            clearable
          />
        </v-col>
      </v-row>
    </v-container>
</template>

<script>

  export default {
    name: 'MenuFilter',
    props: {
      values: {
        type: Object,
        required: true
      }
    },
    data () {
      return {};
    },
    mounted () {
    },

    computed: {
      // eslint-disable-next-line
      item () {
        return this.initialValues || this.values;
      }
    },
    methods: {}
  };
</script>
